export enum FooterLinks {
  TERMS_OF_USE = 'https://www.assistme.io/alea-terms-use/',
  PRIVACY_POLICY = 'https://www.assistme.io/alea-privacy-policy/',
  FAQ = 'https://www.assistme.io/alea-faq/',
  SUBMIT_SUPPORT_REQUEST = 'https://smart-forms.saasjet.com/external/?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRLZXkiOiI3NWRmNzJiYy1iZjEwLTMzYjMtYTA4OC00NTg1NjUzZDNkZmQiLCJpYXQiOjE3NDIyMzQ3OTI3ODJ9.Vn6Ya2F8J2MmZbBIjiIXQ1SZjLnwHNeMyrbHczYt8KE',
  INSTRUCTIONS_FOR_USE = 'https://www.assistme.io/alea-ifu/',
  ABOUT_ASSISTME = 'https://www.assistme.io/alea-company/',
  ALEA_COCKPIT_GUIDE = 'https://www.assistme.io/ifu-alea-cockpit/'
}